import { BaseQuestionnaireRoute } from '../slice';

export type BookKeepingRoutes = BaseQuestionnaireRoute;

export const bookKeepingRoutes: { bookKeeping: BookKeepingRoutes } = {
  bookKeeping: {
    title: 'Bookkeeping',
    path: 'bookKeeping',
    isValid: undefined,
  },
};
